import ServiceLocator from "../ServiceLocator";
import * as PIXI from "pixi.js";

import Card from "./game/Card";
import { Signal } from "signals";
import Input from "./Input";


export default class MouseInput extends Input
{
    public constructor() { super(); }

    public init(): void
    {
        this._onCardSelected = new Signal();

        this._isEnabled = true;

        ServiceLocator.app.stage.on( "pointermove", this._onStage_PointerMove, this );
        ServiceLocator.app.stage.on( "pointerdown", this._onStage_PointerMove, this );
        ServiceLocator.app.stage.on( "pointerup", this._onStage_PointerUp, this );
    }

        private _onStage_PointerMove(): void
        {
            if ( !this._isEnabled ) { return; }

            let selCard: Card = null;
            const kCursorPos = ServiceLocator.app.renderer.plugins.interaction.eventData.data.global;
            let hit: PIXI.DisplayObject = ServiceLocator.app.renderer.plugins.interaction.hitTest( kCursorPos, this._layers.player );
            if ( hit && hit instanceof Card )
            {
                if ( this._baseCardY === null )
                {
                    this._baseCardY = hit.y;
                }
                selCard = hit;
            }

            if ( selCard != this._selCard )
            {
                if ( this._selCard )
                {
                    this._selCard.y = this._baseCardY;
                    //( ( this._selCard.parent as any )._shadowWrapper.children[ 0 ] as PIXI.Sprite ).y = this._selCard.y - 10;
                }
                if ( selCard )
                {
                    selCard.y = this._baseCardY - 30;
                    //( ( selCard.parent as any )._shadowWrapper.children[ 0 ] as PIXI.Sprite ).y = selCard.y - 10;
                }
            }
            this._selCard = selCard;
        }

        private _onStage_PointerUp(): void
        {
            if ( !this._isEnabled ) { return; }

            if ( this._selCard )
            {
                this._onCardSelected.dispatch( this._selCard );
            }
        }

    public end(): void
    {
        ServiceLocator.app.stage.off( "pointermove", this._onStage_PointerMove, this );
        ServiceLocator.app.stage.off( "pointerdown", this._onStage_PointerMove, this );
        ServiceLocator.app.stage.off( "pointerup", this._onStage_PointerUp, this );
    
        this._onCardSelected.dispose();
        this._onCardSelected = null;
    }

    public clearSelectedCard(): void
    {
        if ( this._selCard )
        {
            this._selCard.y = this._baseCardY;
            //( ( this._selCard.parent as any )._shadowWrapper.children[ 0 ] as PIXI.Sprite ).y = this._selCard.y - 10;
            this._selCard = null;
        }
    }

    public setEnabled( isEnabled: boolean ): void
    {
        this._isEnabled = isEnabled;

        if ( !isEnabled )
        {
            if ( this._selCard )
            {
                this._selCard.y = this._baseCardY;
                //( ( this._selCard.parent as any )._shadowWrapper.children[ 0 ] as PIXI.Sprite ).y = this._selCard.y - 10;
                this._selCard = null;
            }
        }
        else
        {
            this._onStage_PointerMove();
        }
    }
}